import axios from "axios";

import store from "../store/index";

function APIException(name, message) {
  this.name = name;
  this.message = message;
}

export async function callAPI(path, method, payload, authenticated) {
  let params = null;
  let body = null;
  if (method === "GET") {
    params = payload;
  } else {
    body = payload;
  }

  let headers = {
    "Content-Type": "application/json"
  };
  if (authenticated) {
    headers["Authorization"] = `Bearer ${store.getters["auth/getAccessToken"]}`;
  }

  try {
    const result = await axios({
      url: `${process.env.VUE_APP_API_URL}${path}`,
      method: method,
      headers: headers,
      params: params,
      data: body
    });

    if (result.data == null) {
      return null;
    }

    return result.data.data;
  } catch (e) {
    if (e.response && e.response.data && e.response.data.status != 200) {
      throw new APIException(e.response.data.error, e.response.data.message);
    }

    throw e;
  }
}
